import { render, staticRenderFns } from "./CustomerContextPrompt.vue?vue&type=template&id=1ab4d229&scoped=true&"
import script from "./CustomerContextPrompt.vue?vue&type=script&lang=js&"
export * from "./CustomerContextPrompt.vue?vue&type=script&lang=js&"
import style0 from "./CustomerContextPrompt.vue?vue&type=style&index=0&id=1ab4d229&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab4d229",
  null
  
)

export default component.exports